import { render, staticRenderFns } from "./access-denied.vue?vue&type=template&id=6c127547&scoped=true&"
import script from "./access-denied.vue?vue&type=script&lang=js&"
export * from "./access-denied.vue?vue&type=script&lang=js&"
import style0 from "./access-denied.vue?vue&type=style&index=0&id=6c127547&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c127547",
  null
  
)

export default component.exports